// src/store/slices/headerSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    branches: [],
    notification: {},
    expirationMessage: {},
    remainingMessage: {},
    // Only move essential state to Redux
    notificationUI: {
        isAllChecked: false,
        checkedClients: [],
        isNotificationSeen: true,
        selectedCardItem: {},
    }
};

const headerSlice = createSlice({
    name: 'header',
    initialState,
    reducers: {
        setBranches: (state, action) => {
            state.branches = action.payload;
        },
        setNotification: (state, action) => {
            state.notification = action.payload;
        },
        setExpirationMessage: (state, action) => {
            state.expirationMessage = action.payload;
        },
        setRemainingMessage: (state, action) => {
            state.remainingMessage = action.payload;
        },
        resetHeaderState: () => initialState,
        setAllChecked: (state, action) => {
            state.notificationUI.isAllChecked = action.payload;
        },
        setCheckedClients: (state, action) => {
            state.notificationUI.checkedClients = action.payload;
        },
        setNotificationSeen: (state, action) => {
            state.notificationUI.isNotificationSeen = action.payload;
        },
        setSelectedCardItem: (state, action) => {
            state.notificationUI.selectedCardItem = action.payload;
        }
    }
});

export const {
    setBranches,
    setNotification,
    setExpirationMessage,
    setRemainingMessage,
    resetHeaderState,
    setAllChecked,
    setCheckedClients,
    setNotificationSeen,
    setSelectedCardItem
} = headerSlice.actions;

export default headerSlice.reducer;